<template>
    <div class="login-container">
        <div class="forgot-password-panel">
            <div class="forgot-password-title">
                <span v-text="title"></span>
                <img src="../../assets/images/x-icon-grey.svg" alt="X" @click="actionBackToLogin">
            </div>
            <div class="forgot-password-desc" v-text="description"></div>
            <text-input label="E-mail" :init-value="email" ref="email"/>
            <text-button label="Submit" :loading-state="loadingState" @click="actionSubmit"/>
        </div>
    </div>
</template>

<script>
    import TextInput from "../components/TextInput";
    import TextButton from "../components/TextButton";

    export default {
        name: "ForgotPassword",
        components: {TextButton, TextInput},
        computed: {
            email() {
                return '';
            },
            title() {
                return 'Forgot your password?';
            },
            description() {
                return 'Enter your email address to reset your password. You may need to check your spam folder.';
            }
        },
        data() {
            return {
                loadingState: false,
            }
        },
        methods: {
            actionBackToLogin() {
                this.$router.push(this.$enums.RoutePathEnum.LOGIN);
            },
            actionSubmit() {
                let email = this.$refs.email.value;

                this.loadingState = true;

                this.$api.resetPassword({
                    data: {
                        email: email,
                    }
                }).then(() => {
                    this.actionBackToLogin();
                }).finally(() => {
                    this.loadingState = false;
                });
            }
        },
    }
</script>
